<ng-template #settingsTemplate>
    <app-tool-setting label="Vermenigvuldig">
        <app-check-box
            [checked]="isMultiply"
            (checkedChange)="toggleMultiply()"
            label="vermenigvuldigen"
        ></app-check-box>
    </app-tool-setting>
    <app-tool-setting label="Vul in">
        <app-numbers-input
            (numberChoice)="handleNumberChoice($event)"
            (undo)="handleUndo()"
            (clear)="handleClear()"
        ></app-numbers-input>
    </app-tool-setting>
</ng-template>
<ng-template #contentTemplate>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 227.9 217.22"
        style="height: 280px"
    >
        <defs>
            <style>
                .cTriangle-1,
                .cTriangle-12,
                .cTriangle-5 {
                    fill: none;
                }
                .cTriangle-2,
                .cTriangle-3,
                .cTriangle-8 {
                    fill: #fff;
                }
                .cTriangle-2 {
                    stroke: #0090c9;
                }
                .cTriangle-2,
                .cTriangle-3,
                .cTriangle-7 {
                    stroke-width: 1.5px;
                }
                .cTriangle-3 {
                    stroke: #0091d5;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                }
                .cTriangle-4 {
                    clip-path: url(#clip-path);
                }
                .cTriangle-12,
                .cTriangle-5 {
                    stroke: #a1a1a1;
                }
                .cTriangle-5 {
                    stroke-width: 0.91px;
                }
                .cTriangle-6 {
                    font-size: 26px;
                    font-family: UniversLTStd, Univers LT Std;
                }
                .cTriangle-7 {
                    fill: #0090c9;
                    stroke: #fff;
                }
                .cTriangle-9 {
                    clip-path: url(#clip-path-2);
                }
                .cTriangle-10 {
                    clip-path: url(#clip-path-3);
                }
                .cTriangle-11 {
                    clip-path: url(#clip-path-4);
                }
                .cTriangle-12 {
                    stroke-width: 0.91px;
                }
                .cTriangle-13 {
                    clip-path: url(#clip-path-5);
                }
                .cTriangle-14 {
                    clip-path: url(#clip-path-6);
                }
            </style>
            <clipPath id="clip-path" transform="translate(0 -0.78)">
                <rect class="cTriangle-1" x="96" y="75" width="39" height="1" />
            </clipPath>
        </defs>
        <g class="counting-triangle-item-fields">
            <g class="field1" (click)="setActiveField(0)">
                <rect
                    class="cTriangle-2 field1"
                    x="0.75"
                    y="40.44"
                    width="46.5"
                    height="46.5"
                />
                <text
                    class="cTriangle-6"
                    text-anchor="middle"
                    transform="translate(23.75 73.41)"
                >
                    {{ values[0] }}
                </text>
                @if (activeField === 0) {
                <g class="cTriangle-10">
                    <line
                        class="cTriangle-5"
                        x1="7.5"
                        y1="78.72"
                        x2="39.5"
                        y2="78.72"
                    />
                </g>
                }
            </g>
            <g class="field2" (click)="setActiveField(1)">
                <polygon
                    class="cTriangle-3 field2"
                    points="113.95 0.75 70.35 76.27 113.67 101.28 113.95 101.44 114.23 101.28 157.55 76.27 113.95 0.75"
                />
                <text
                    class="cTriangle-6"
                    text-anchor="middle"
                    transform="translate(115 67.41)"
                >
                    {{ values[1] }}
                </text>
                @if (activeField === 1) {
                <g class="cTriangle-4">
                    <line
                        class="cTriangle-5"
                        x1="96"
                        y1="74.72"
                        x2="135"
                        y2="74.72"
                    />
                </g>
                }
            </g>
            <g class="field3" (click)="setActiveField(2)">
                <rect
                    class="cTriangle-2 field3"
                    x="180.65"
                    y="40.44"
                    width="46.5"
                    height="46.5"
                />
                <text
                    class="cTriangle-6"
                    text-anchor="middle"
                    transform="translate(203.75 73.41)"
                >
                    {{ values[2] }}
                </text>
                @if (activeField === 2) {
                <g class="cTriangle-9">
                    <line
                        class="cTriangle-5"
                        x1="187.5"
                        y1="78.72"
                        x2="219.5"
                        y2="78.72"
                    />
                </g>
                }
            </g>
            <g class="field4" (click)="setActiveField(3)">
                <polygon
                    class="cTriangle-3 field4"
                    points="26.75 151.79 113.95 151.79 113.95 101.44 70.35 76.27 26.75 151.79"
                />
                <text
                    class="cTriangle-6"
                    text-anchor="middle"
                    transform="translate(75 133.41)"
                >
                    {{ values[3] }}
                </text>
                @if (activeField === 3) {
                <g class="cTriangle-14">
                    <line
                        class="cTriangle-5"
                        x1="60.33"
                        y1="138.37"
                        x2="92.33"
                        y2="138.37"
                    />
                </g>
                }
            </g>
            <g class="field5" (click)="setActiveField(4)">
                <polygon
                    class="cTriangle-3 field5"
                    points="201.15 151.79 157.55 76.27 113.95 101.44 113.95 151.79 201.15 151.79"
                />
                <text
                    class="cTriangle-6"
                    text-anchor="middle"
                    transform="translate(150 133.41)"
                >
                    {{ values[4] }}
                </text>
                @if (activeField === 4) {
                <g class="cTriangle-13">
                    <line
                        class="cTriangle-5"
                        x1="134.33"
                        y1="138.37"
                        x2="166.33"
                        y2="138.37"
                    />
                </g>
                }
            </g>
            <g class="field6" (click)="setActiveField(5)">
                <rect
                    class="cTriangle-2 field6"
                    x="91.45"
                    y="169.97"
                    width="46.5"
                    height="46.5"
                />
                <text
                    class="cTriangle-6"
                    text-anchor="middle"
                    transform="translate(114.75 202.41)"
                >
                    {{ values[5] }}
                </text>
                @if (activeField === 5) {
                <g class="cTriangle-11">
                    <line
                        class="cTriangle-12"
                        x1="98.33"
                        y1="208.37"
                        x2="130.33"
                        y2="208.37"
                    />
                </g>
                }
            </g>
        </g>
        @if (isMultiply) {
        <g id="X-sign">
            <path
                class="cTriangle-7"
                d="M114,116.3a15.58,15.58,0,1,0-15.58-15.58A15.57,15.57,0,0,0,114,116.3Z"
                transform="translate(0 -0.78)"
            />
            <path
                class="cTriangle-8"
                d="M112.11,101.31,108.77,98l1.84-1.85L114,99.47l3.34-3.37L119.13,98l-3.34,3.36,3.34,3.34-1.84,1.84L114,103.13l-3.34,3.36-1.84-1.84Z"
                transform="translate(0 -0.78)"
            />
        </g>
        }
    </svg>
</ng-template>
